
import { IDDocumentType } from "@/hooks/admin/identity-docs/useIDTypes";

// Determine document purpose based on selected document type and country
export const determineDocumentPurpose = (
  documentTypeId: string,
  countryCode: string,
  sectionIndex: number,
  idTypes: IDDocumentType[] | undefined,
  verificationCountry: string,
  residencyStatus: string,
  documentsNeeded: any[]
) => {
  if (!documentTypeId || !idTypes) return "primary";

  const documentType = idTypes.find((type) => type.id === documentTypeId);
  if (!documentType) return "primary";

  const isVerificationCountry = countryCode === verificationCountry;
  const isExpatriate = residencyStatus === "expatriate";

  // If it's a passport or citizenship document from another country for an expatriate
  if (
    isExpatriate &&
    !isVerificationCountry &&
    documentType.proves_citizenship
  ) {
    return "expatriate";
  }

  // If it's a residency document for the verification country for an expatriate
  if (
    isExpatriate &&
    isVerificationCountry &&
    documentType.proves_residency
  ) {
    return "expatriate";
  }

  // If it proves both citizenship and residency
  if (documentType.proves_citizenship && documentType.proves_residency) {
    return "both";
  }

  // Default to the document type based on section index
  if (documentsNeeded[sectionIndex]) {
    return documentsNeeded[sectionIndex].type;
  }

  return "primary";
};

// Get document label based on purpose
export const getDocumentPurposeLabel = (purpose: string) => {
  switch (purpose) {
    case "primary":
      return "Primary ID";
    case "expatriate":
      return "Expatriate Document";
    case "both":
      return "Primary & Expatriate";
    case "passport":
      return "Passport";
    case "residency":
      return "Residency Document";
    default:
      return purpose;
  }
};

// Get document type display name
export const getDocumentTypeName = (docTypeId: string, idTypes: IDDocumentType[] | undefined) => {
  if (!idTypes) return "Document";
  const docType = idTypes.find((t) => t.id === docTypeId);
  return docType ? docType.document_name : "Document";
};

// Get country name
export const getCountryName = (countryCode: string, countries: any[]) => {
  if (!countries) return countryCode;
  const country = countries.find((c) => c.code === countryCode);
  return country ? country.name : countryCode;
};
